module.exports = __webpack_public_path__ + "static/media/sf-test-13.39f74275.mp3";